import axios from 'axios';
import { Module, VuexModule, Action, Mutation } from 'vuex-module-decorators';
import { ReportElementType } from '@/models/ReportElement';

axios.defaults.baseURL = process.env.VUE_APP_API_URL;

@Module({ namespaced: true })
class ReportElementTypeModule extends VuexModule {
    _all: any = [];

    get all() {
        return this._all;
    }

    @Mutation
    add(type: ReportElementType) {
        if (this._all.findIndex((t: ReportElementType) => type.id === t.id) > -1) {
            return;
        }
        this._all.push(type);
    }

    @Action
    async init() {
        try {
            const r = await axios({
                method: 'GET',
                url: '/api/report_element_types',
            });

            if (r.status !== 200) {
                throw Error('ReportElementType READ failed.');
            }
            r.data['hydra:member'].map((data: any) => {
                this.context.commit('add', new ReportElementType(data));
            });
        } catch (e) {
            return e;
        }
    }
}

export default ReportElementTypeModule;
